import { render, staticRenderFns } from "./ChannelConfigModal.vue?vue&type=template&id=141c170b&scoped=true"
import script from "./ChannelConfigModal.vue?vue&type=script&lang=js"
export * from "./ChannelConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ChannelConfigModal.vue?vue&type=style&index=0&id=141c170b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c170b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141c170b')) {
      api.createRecord('141c170b', component.options)
    } else {
      api.reload('141c170b', component.options)
    }
    module.hot.accept("./ChannelConfigModal.vue?vue&type=template&id=141c170b&scoped=true", function () {
      api.rerender('141c170b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/channel/components/ChannelConfigModal.vue"
export default component.exports